import moment from 'moment/moment';
import 'moment/locale/ru';

export default {
  install(Vue) {

    Vue.prototype.$moment = moment;
  },
};
